import { vector } from '../../common/types.js';
import { KeyScale } from '../axis/key/KeyScale.js';
import { ValueScale } from '../axis/value/ValueScale.js';
import { getNextProjectedPoint } from './interpolation.js';
import { lineRenderGroupData } from './line/types.js';
import { curvedSegment, linearSegment } from './types.js';
export const toLinearSegments = (keyScale: KeyScale, valueScale: ValueScale, line: lineRenderGroupData[]): linearSegment[] => {
  const validIndices = getValidIndices(line);
  const segments: linearSegment[] = [];
  for (let i = 0; i < validIndices.length - 1; i++) {
    const currentValidIndex = validIndices[i];
    const nextValidIndex = validIndices[i + 1];
    if (currentValidIndex + 1 !== nextValidIndex) {
      continue;
    }
    const current = line[currentValidIndex];
    const next = line[nextValidIndex];
    segments.push({
      type: 'linear',
      key: current.key,
      startPoint: [keyScale.center(current.key), valueScale.position(current.value)],
      endPoint: [keyScale.center(next.key), valueScale.position(next.value)]
    });
  }
  return segments;
};
export const toCurvedSegments = (keyScale: KeyScale, valueScale: ValueScale, line: lineRenderGroupData[]): curvedSegment[] => {
  const validIndices = getValidIndices(line);
  const segments: curvedSegment[] = [];
  for (let i = 0; i < validIndices.length - 1; i++) {
    const currentValidIndex = validIndices[i];
    const nextValidIndex = validIndices[i + 1];
    if (currentValidIndex + 1 !== nextValidIndex) {
      continue;
    }
    const current = line[currentValidIndex];
    const next = line[nextValidIndex];
    const isFirst = i === 0;
    const isLast = i + 1 === validIndices.length - 1;
    const startPoint: vector = [keyScale.center(current.key), valueScale.position(current.value)];
    const endPoint: vector = [keyScale.center(next.key), valueScale.position(next.value)];
    const ghostStartPoint: vector = isFirst ? getNextProjectedPoint(endPoint[0], endPoint[1], startPoint[0], startPoint[1]) : [keyScale.center(line[validIndices[i - 1]].key), valueScale.position(line[validIndices[i - 1]].value)];
    const ghostEndPoint: vector = isLast ? getNextProjectedPoint(startPoint[0], startPoint[1], endPoint[0], endPoint[1]) : [keyScale.center(line[validIndices[i + 2]].key), valueScale.position(line[validIndices[i + 2]].value)];
    segments.push({
      type: 'curved',
      key: current.key,
      ghostStartPoint,
      startPoint,
      endPoint,
      ghostEndPoint
    });
  }
  return segments;
};
const getValidIndices = (line: lineRenderGroupData[]) => {
  return line.reduce<number[]>((acc, current, index) => {
    if (current.value != null) {
      acc.push(index);
    }
    return acc;
  }, []);
};